import axios from "axios";
import { getToken } from "./auth";

const API_URL = process.env.REACT_APP_API_BASE_URL;

// Axios instance with base URL
const axiosInstance = axios.create({
  baseURL: API_URL,
});

// Automatically attach JWT token
axiosInstance.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle token expiration
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      // Clear auth data
      const Cookies = require("js-cookie").default;
      Cookies.remove("auth_token");
      Cookies.remove("user");
      // Redirect to login
      window.location.href = "/login";
    }
    return Promise.reject(error);
  },
);

/**
 * Unified response handler
 */
const handleResponse = (res, actionDesc = "Request") => {
  const { success, message, ...rest } = res.data || {};
  return {
    success,
    message: message || `${actionDesc} completed`,
    ...rest,
  };
};

/**
 * Get performance parameters
 */
export const getPerformanceParameters = async () => {
  try {
    const res = await axiosInstance.get("/Dashboard/GetPerformanceParameters");
    return handleResponse(res, "Get performance parameters");
  } catch (err) {
    console.error("Error fetching performance parameters:", err);
    throw err;
  }
};

/**
 * Agents Kpi endpoint
 */
export const agentsKpi = async () => {
  try {
    const res = await axiosInstance.get("/Dashboard/AgentsKpi");
    return handleResponse(res, "Agetns Kpi");
  } catch (err) {
    console.error("Error fetching Agents Kpi data:", err);
    throw err;
  }
};

/**
 * Update a performance parameter
 * @param {Object} data - request body
 * @param {string} data.parameterName
 * @param {string} data.performanceValue
 * @param {string} data.username
 * @param {string} data.companyCode
 * @param {string} data.validFrom - ISO string like "2025-09-15T07:13:54.555"
 * @param {string} data.validTo - ISO string like "2025-09-15T07:13:54.555"
 * @returns {Promise<Object>} - success response from API
 */
export async function updatePerformanceParameter(data) {
  try {
    const response = await axiosInstance.post(
      "/Dashboard/UpdatePerformanceParameter",
      data,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    // Expected response: { success: true, message: "..." }
    return response.data;
  } catch (error) {
    console.error("Error updating performance parameter:", error);
    throw error;
  }
}
